/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {

		connectedCallback() {
			this.ticking = false;
			this._onScroll = this.checkVisible.bind(this);
			this._onResize = () => { this.pageHeight = window.innerHeight; };

			this.pageHeight = window.innerHeight;

			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, { passive: true });
			this.addEventListener('keydown', this.onKeydown);
			window.addEventListener('scroll', this._onScroll, { passive: true });
			window.addEventListener('resize', this._onResize, { passive: true });
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this._onScroll);
			window.removeEventListener('resize', this._onResize);
		}

		checkVisible() {
			if (this.ticking) return;
			this.ticking = true;
			window.requestAnimationFrame(() => {
				this.classList.toggle('back-to-top--active', window.scrollY > this.pageHeight);
				this.ticking = false;
			});
		}

		onKeydown(e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				this.onClick();
			}
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? "instant" : "smooth"
			});
			document.getElementById('main-content')?.focus({ preventScroll: true });
		}
	}
	customElements.define('back-to-top', BackToTop);
}
